import React, { useEffect } from "react";
import { useProductData } from "@/zustand/productStore";
import { useCartData } from "@/zustand/cartStore";
import CheckIcon from "@/public/fallbacks/check.svg";

const ExtendedWarrantyCheckbox = () => {
  const base = window.post_template;
  const productData = useProductData();
  const { selectedProduct, warrantyState, setWarrantyState } = useCartData();
  const productPackWarrantyCheckboxTitle = productData?.warrantyTexts?.tr_product_pack_warranty_box_title;
  const checkoutWarrantyCheckboxTitle = base?.checkout_v4_warranty.tr_checkout_v4_warrantyCheckboxHeading;
  const warrantyLabelRendered = productPackWarrantyCheckboxTitle
    ? productPackWarrantyCheckboxTitle
    : checkoutWarrantyCheckboxTitle;

  useEffect(() => {
    if (productData?.preselect_warranty) {
      setWarrantyState(true);
    } else {
      setWarrantyState(false);
    }
  }, [productData]);

  const formatedAmount = productData?.formatted_string?.replace(/(0\.00|0,00|0)/, selectedProduct?.warranty_price);

  const warrantyLabel = warrantyLabelRendered.replace("###react_warrPrice###", formatedAmount);

  const toggleWarrantyCheckbox = () => {
    setWarrantyState(!warrantyState);
  };

  return (
    <>
      <section className="warrantyContainer">
        <div className="warranty__checkbox">
          {warrantyState !== undefined && (
            <input
              className="warranty__input"
              defaultChecked={warrantyState}
              type="checkbox"
              id="warranty"
              onClick={() => {
                toggleWarrantyCheckbox();
              }}
            />
          )}
          <label data-cy="cc-warranty-select" className="warranty__label" htmlFor="warranty">
            {warrantyLabel ?? "Yes, I Want The Extended Protection"}
          </label>
          <label htmlFor="warranty" className="warranty__check">
            <span style={{ backgroundImage: `url(${CheckIcon})` }}></span>
          </label>
        </div>
      </section>
    </>
  );
};

export default ExtendedWarrantyCheckbox;
